export default function(r) {
  r
    .keys()
    .filter(r => !r.match(/__test__/))
    .forEach(r);
}
